import { render, staticRenderFns } from "./DayLabelHeader.vue?vue&type=template&id=b8ac84b4&scoped=true&"
import script from "./DayLabelHeader.vue?vue&type=script&lang=js&"
export * from "./DayLabelHeader.vue?vue&type=script&lang=js&"
import style0 from "./DayLabelHeader.vue?vue&type=style&index=0&id=b8ac84b4&scoped=true&lang=css&"
import style1 from "./DayLabelHeader.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8ac84b4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VBtn,VCol,VRow,VSheet})
